/**
 * Model configuration
 */
export const config = {
  modelName: 'file',
  allowedFiles: '.pdf, .jpeg, .jpg, .xls, .xlsx',
  maxFileSize: 10 * 1024 * 1024,
} as const;
